export const DEFAULT_TEAM_PRICING_CONFIG = {
  pricePerTeamMember: 0,
  trialDurationDays: "",
  minimumSeatCount: "",
  maximumSeatCount: "",
};

export const normalizeWholeNumberInput = (value) => {
  if (value === "") return "";

  const digitsOnly = value.replace(/\D/g, "");
  if (digitsOnly === "") return "";

  return digitsOnly.replace(/^0+(?=\d)/, "");
};

export const getPlanTeamPricingConfig = (plan) => ({
  ...DEFAULT_TEAM_PRICING_CONFIG,
  pricePerTeamMember: Number(plan?.pricePerTeamMember) || 0,
  trialDurationDays:
    plan?.trialDurationDays !== undefined && plan?.trialDurationDays !== null
      ? String(plan.trialDurationDays)
      : DEFAULT_TEAM_PRICING_CONFIG.trialDurationDays,
  minimumSeatCount:
    plan?.minimumSeatCount !== undefined && plan?.minimumSeatCount !== null
      ? String(plan.minimumSeatCount)
      : DEFAULT_TEAM_PRICING_CONFIG.minimumSeatCount,
  maximumSeatCount:
    plan?.maximumSeatCount !== undefined && plan?.maximumSeatCount !== null
      ? String(plan.maximumSeatCount)
      : DEFAULT_TEAM_PRICING_CONFIG.maximumSeatCount,
});

export const getTeamPricingSummary = (config) => {
  const minSeats = Number(config.minimumSeatCount) || 0;
  const maxSeats = Number(config.maximumSeatCount) || 0;
  const unitPrice = Number(config.pricePerTeamMember) || 0;

  return {
    minSeats,
    maxSeats,
    minTotal: minSeats * unitPrice,
    maxTotal: maxSeats * unitPrice,
  };
};
